import { render, staticRenderFns } from "./App.vue?vue&type=template&id=88e79386&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=88e79386&prod&lang=less&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=88e79386&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e79386",
  null
  
)

export default component.exports